<template>
  <ValidationObserver v-slot="{ handleSubmit }" slim>
    <form ref="observer" @submit.prevent="handleSubmit(validateForm)" class="form-guest">
      <ValidationProvider rules="required|email" name="Email" v-slot="{ errors }" tag="div" class="form-guest__group">
        <float-label>
          <input type="email" name="email" placeholder="Email" :value="value.email"
                 @input="update('email', $event.target.value)">
        </float-label>
        <span v-show="errors" class="form-guest__errors">{{ errors[0] }}</span>
      </ValidationProvider>
      <ValidationProvider rules="required" name="Password" v-slot="{ errors }" tag="div" class="form-guest__group">
        <float-label>
          <input type="password" name="password" placeholder="Password" :value="value.password"
                 @input="update('password', $event.target.value)" id="password-login">
          <fa :icon="loginPasswordIcon" @click="togglePasswordVisibility('login')" class="form-guest__password-icon"></fa>
        </float-label>
        <span v-show="errors" class="form-guest__errors">{{ errors[0] }}</span>
      </ValidationProvider>
      <v-button class="btn btn-primary" group="auth">sign in</v-button>
    </form>
  </ValidationObserver>
</template>

<script>
import FormMixin from '@/components/mixins/FormMixin';
import Button from '@/components/utils/Button';

export default {
  name: 'login-form',
  mixins: [FormMixin],
  components: {
    'v-button': Button,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
};
</script>
